<div class="root">
  <ng-container *ngFor="let item of possibleValues">
    <div
      class="tag-option"
      [class.selected]="item === value"
      (click)="handleSelection(item)"
    >
      <span>{{ item }}</span>
    </div>
  </ng-container>
</div>
